import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  FormGroup,
  FormInput,
  FormSelect,
  FormTextarea,
  Button
} from "shards-react";

const Disclaimer = ({ title }) => (
  <Card small className="mb-4">
    <CardHeader className="border-bottom">
      <h6 className="m-0">{title}</h6>
    </CardHeader>
    <ListGroup flush>
      <ListGroupItem className="p-3">
        
      <strong>Last updated March 29, 2020 <br></br>

Bangalore, India</strong><br></br><br></br>

The information provided by this website is for general informational purposes only. 
All the data on the site shown is fetched from an open source <a href="https://github.com/covid19india/api">API</a>{" "}
and is provided in good faith however I do not make a warranty of any kind, 
express or implied, regarding the accuracy, adequacy, validity, 
reliability, availability or completeness of any information. 
For all the information, external source links are provided. 
The external links are not regularly investigated, monitored, 
or checked for accuracy, adequacy, validity, reliability, availability 
or completeness by me. The latest news are being fetched using <a href="https://newsapi.org/">NewsAPI.org</a>. 
The website is hosted on <a href="https://www.netlify.com/">Netlify</a> and the source code can be found on <a href="https://github.com/vinitshahdeo/COVID19"><strong>GitHub</strong></a>.

      </ListGroupItem>
      
      
    </ListGroup>
  </Card>
);

Disclaimer.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string
};

Disclaimer.defaultProps = {
  title: "Disclaimer"
};

export default Disclaimer;
